import React from 'react';
import PageBanner from "@/components/pageBanner";
import {Heading} from "@/components/ui/heading";
import Paths from "../constants/Paths";
import {Button} from "@/components/ui/button";
import {Link, useNavigate} from "react-router-dom";
import Faq from "./home/Faq";
import AffilateProgramElements from "@/components/affilateProgramElements";

const ProgramAfiliacyjny = () => {
    const navigate = useNavigate();

    const handleJoinNow = () => {
        // scroll to #footer-section
        /*
        const footerSection = document.getElementById("footer-section");
        if (footerSection) {
            footerSection.scrollIntoView({ behavior: "smooth" });
        }
         */

        window.open(Paths.DISCORD, "_blank");
    }

    return (
        <>
            <PageBanner title="Affiliate Program" slug="affiliate-program" />
            <section className="affiliate-program-main-section generic-container py-14">
                <div style={{textAlign: 'center'}}>
                    <Heading level={2}>
                        What is the Locked Trade affiliate program?
                    </Heading>
                </div>
                <p>
                    Get paid commission for recommending Locked Trade tools.
                </p>
                <div className={`text-center`}>
                    <button onClick={() => handleJoinNow()} className="big-button dark-variant mx-auto mt-14">Join now</button>
                </div>
            </section>
            <section className="affiliate-program-second-section py-14 dark-bg-with-gradients">
                <div className='generic-container'>
                    <Heading level={2}>
                        How to Join Locked Trade Affiliate Program?
                    </Heading>
                    <AffilateProgramElements/>

                    <div className={`text-center`}>
                        <Link to={Paths.AFFILIATE_PROGRAM_REGULATIONS} className="big-button white-variant mx-auto mt-14">Affiliate program regulations</Link>
                    </div>
                </div>
            </section>
            <Faq page="affiliate-program"/>
        </>
    );
};

export default ProgramAfiliacyjny;